import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { addBreadcrumb, setSentryContext } from 'config/sentryConfig';
import { redactSensitivePath } from 'config/sentryEventContext';

const SentryRouteTracker = () => {
  const location = useLocation();
  const previousPathRef = useRef<string | null>(null);

  useEffect(() => {
    const to = redactSensitivePath(location.pathname, location.search);
    const from = previousPathRef.current;

    setSentryContext('route', { path: to });

    addBreadcrumb({
      category: 'navigation',
      type: 'navigation',
      level: 'info',
      data: from ? { from, to } : { to },
    });

    previousPathRef.current = to;
  }, [location.pathname, location.search]);

  return null;
};

export default SentryRouteTracker;
